import * as React from 'react';
import styled from 'styled-components';

import { ModalDefaultDraggable } from '../molecules';
import { getCurrentUser } from '../api/userSettings';
import CompletedInspectionsList, {
  CompletedInspection,
} from '../organisms/CompletedInspectionsList';
import InspectionsPage from './Permits/InspectionsPage';

const CompletedInspectionsPage = ({ month, year }: Props) => {
  const [currentUser, setCurrentUser] = React.useState<number | null>(null);
  const [isPermitModalOpen, setPermitModal] = React.useState(false);
  const [permit, setPermit] = React.useState<number | null>(null);
  const [projectId, setProjectId] = React.useState<number | null>(null);

  React.useEffect(() => {
    getCurrentUser().then(res => setCurrentUser(res.data.id));
  }, []);

  const handleSelectInspection = (inspection: CompletedInspection) => {
    setPermit(inspection.permit ?? null);
    setProjectId(inspection.projectId ?? null);
    setPermitModal(true);
  };

  return (
    <Container>
      <CompletedInspectionsList
        inspectorId={currentUser}
        month={month}
        year={year}
        onSelectInspection={handleSelectInspection}
      />

      {isPermitModalOpen && (
        <StyledModalDraggable
          title="Permit Inspections"
          onClose={() => setPermitModal(false)}
          extraWide
        >
          <InspectionsPage
            projectId={projectId}
            permit={permit}
            isAddInspection={false}
            setAddInspection={() => undefined}
            isReadOnly
          />
        </StyledModalDraggable>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  margin-top: 12px;
`;

const StyledModalDraggable = styled(ModalDefaultDraggable)`
  height: 100%;
  overflow: inherit;
`;

interface Props {
  month: number | null;
  year: number | null;
}

export default CompletedInspectionsPage;
